import { useCallback, useEffect, useMemo, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import useAuthContext from '../../apps/common/modules/auth/hooks/useAuthContext';
import StorageService from '../../Services/storage/storage.service';
import Constants from '../../utils/Constants';
import { INavFeedlotCPO } from '../../utils/Interface/NavInterface';
import { useAppDispatch, useAppSelector } from '../../Redux/Store';
import { setFeedlotCPOToUpdate } from '../../Redux/Reducer/common';
import { authActions } from '../../apps/common/modules/auth/authSlice';
import { apiCall_v2 } from '../../Services/AxiosService';
import { IShipPoDestination } from '../../apps/shippingTracker/modules/shippo/interfaces/ShipPosInterface';

export default function FeedlotDropdownCPO({ path }: { path: string }) {
    const dispatch = useAppDispatch();
    const [usersFeedlots, setUsersFeedlots] = useState<IShipPoDestination[]>(
        [],
    );
    const { selectedFeedlotCPO } = useAppSelector(state => state.common);
    const storage = useMemo(() => new StorageService(), []);
    const { getAccessToken, getLocalStorageKey } = useAuthContext();

    const updateSelectedFeedlot = useCallback(
        async (
            feedlotDetail: IShipPoDestination,
            newFeedlotSelected = false,
        ) => {
            storage.setValue(
                Constants.StorageItems.SELECTED_FEEDLOT_CPO,
                feedlotDetail,
                Constants.Storage.LOCAL,
            );
            if (newFeedlotSelected) {
                window.location.reload();
            } else {
                dispatch(setFeedlotCPOToUpdate(feedlotDetail));
            }
        },
        [dispatch, storage, path],
    );

    useEffect(() => {
        const updateFeedlotDropdownAndSelection = async () => {
            dispatch(
                authActions.setAccessToken({
                    accessToken: getAccessToken(),
                    storageKey: getLocalStorageKey(),
                }),
            );
            const allFeedlots: IShipPoDestination[] = await apiCall_v2({
                method: 'get',
                url:
                    path === '/buypos'
                        ? `${Constants.apiUrls.BUY_PO_INFO}${Constants.apiUrls.BUYPO_DESTINATION}?filter=IsActive eq true&orderBy=Name&includeFMFeedlots=true`
                        : `${Constants.apiUrls.SHIP_PO}${Constants.apiUrls.SHIPPO_LOCATION}?filter=IsActive eq true&orderBy=Name&includeFMFeedlots=true`,
            });
            const usersFeedlots = allFeedlots.sort((a, b) => {
                if (a.name && b.name) {
                    return a.name > b.name ? 1 : -1;
                } else {
                    return 0;
                }
            });
            setUsersFeedlots(usersFeedlots);

            const selectedFeedlotFromStorage: INavFeedlotCPO = storage.getValue(
                Constants.StorageItems.SELECTED_FEEDLOT_CPO,
            );
            const matchingFeedlot = usersFeedlots.find(
                usersFeedlot =>
                    usersFeedlot.id === selectedFeedlotFromStorage?.id,
            );
            await updateSelectedFeedlot(
                matchingFeedlot ?? usersFeedlots?.[0] ?? {},
            );
        };
        updateFeedlotDropdownAndSelection();
    }, [dispatch, getAccessToken, storage, updateSelectedFeedlot]);

    return (
        <div className="mx-3">
            <Dropdown className="top-header-dropdown">
                {usersFeedlots.length > 1 ? (
                    <>
                        <Dropdown.Toggle className="p-0 d-flex align-items-center">
                            {selectedFeedlotCPO.name || ''}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {usersFeedlots.map((feedlot, index) => (
                                <Dropdown.Item
                                    key={feedlot.id}
                                    onClick={async () => {
                                        await updateSelectedFeedlot(
                                            feedlot,
                                            true,
                                        );
                                    }}
                                    className="p-0 px-1 d-flex align-items-center"
                                >
                                    {feedlot.name}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </>
                ) : (
                    <Dropdown.Toggle
                        className="cursor-default p-0 d-flex align-items-center"
                        bsPrefix="p-0"
                    >
                        {selectedFeedlotCPO.name || ''}
                    </Dropdown.Toggle>
                )}
            </Dropdown>
        </div>
    );
}
